import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LancamentoFolhaRoutingModule } from './lancamento-folha-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LancamentoFolhaRoutingModule
  ]
})
export class LancamentoFolhaModule { }
